import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';


@Component({
  selector: 'app-address-select-popup',
  templateUrl: './address-select-popup.component.html',
  styleUrls: ['./address-select-popup.component.scss'],
  standalone: false
})
export class AddressSelectPopupComponent {
  isMobile: boolean;
  searchInput;
  subscription = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: { whichStep: boolean, address: any },
    public breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<AddressSelectPopupComponent>,
  ) {
    this.subscription.add(this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      }));
  }

  updateAddress(addressCode) {
    this.dialogRef.close(addressCode);
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
